import React from "react";

export default function RoomCard({
  title,
  subtitle,
  action = null,
  className = "",
  contentClassName = "",
  allowOverflow = false,
  children,
}) {
  return (
    <section
      className={`${allowOverflow ? "overflow-visible" : "overflow-hidden"} rounded-[24px] border border-slate-200/80 bg-white shadow-[0_18px_60px_rgba(15,23,42,0.08)] ${className}`}
    >
      {(title || subtitle || action) && (
        <header className="flex items-start justify-between gap-3 border-b border-slate-100 px-4 py-3">
          <div>
            {title && (
              <h2 className="text-[13px] font-semibold uppercase tracking-[0.16em] text-slate-500">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="mt-1 text-xs leading-5 text-slate-500">{subtitle}</p>
            )}
          </div>
          {action}
        </header>
      )}

      <div className={`px-4 py-4 ${contentClassName}`}>{children}</div>
    </section>
  );
}
